<template>
    <b-container>
        <h3 class="text-center">{{ message }}</h3>
    </b-container>
</template>

<script>
export default {
    name: "Error",
    props: {
        message: String
    }
}
</script>

<style scoped>

</style>
